(() => {
  const galaxy = document.querySelector('.pp-galaxy');
  if (!galaxy || galaxy.dataset.ready) return;
  galaxy.dataset.ready = 'true';
  const fragment = document.createDocumentFragment();
  for (let index = 0; index < 52; index++) {
    const star = document.createElement('span');
    const meteor = index >= 48;
    const position = meteor ? index - 48 : index;
    star.className = meteor ? 'pp-meteor' : 'pp-star';
    star.style.cssText = meteor
      ? `top:${9 + position * 21}%;left:${38 + position * 19 % 55}%;width:${72 + position * 23}px;--delay:${-position * 3.7}s;--angle:${-24 - position * 4}deg;--rise:${145 + position * 38}px`
      : `left:${((index * 73.137 + 11) % 100).toFixed(2)}%;top:${((index * 37.719 + 7) % 100).toFixed(2)}%;--size:${index % 7 === 0 ? 2 : index % 3 === 0 ? 1.5 : 1}px;--delay:${-(index % 9)}s;--duration:${7 + index % 8}s`;
    fragment.append(star);
  }
  galaxy.append(fragment);
  const control = document.querySelector('.pp-space-toggle');
  const updateVisibility = () => {
    const paused = document.hidden || control?.getAttribute('aria-pressed') === 'true';
    galaxy.dataset.paused = String(paused);
    document.body.dataset.spacePaused = String(paused);
  };
  if (control) {
    control.hidden = false;
    control.addEventListener('click', () => {
      const paused = control.getAttribute('aria-pressed') !== 'true';
      control.setAttribute('aria-pressed', String(paused));
      const label = `${paused ? 'Resume' : 'Pause'} background animation`;
      control.setAttribute('aria-label', label);
      control.title = label;
      control.firstElementChild.textContent = paused ? '\u25B6' : '\u275A\u275A';
      updateVisibility();
    });
  }
  document.addEventListener('visibilitychange', updateVisibility);
  updateVisibility();
})();